import React from 'react';
import { Link } from 'react-router-dom';
import { useProgressStore } from '../../store/progress';
import { getDesignReadyGames, getLevelsForGame } from '../../data/loadData';
import type { GameId } from '../../data/schemas';

/**
 * Simple sticker book: all earned stickers from completed levels.
 */
export const StickerBookPage: React.FC = () => {
  const stickers = useProgressStore((s) => s.stickers);
  const unlocks = useProgressStore((s) => s.unlocks);

  const catalog = getDesignReadyGames().flatMap((game) => {
    const levels = getLevelsForGame(game.id as GameId);
    return levels.map((level) => ({
      sticker: level.reward.sticker,
      title: level.title,
      gameTitle: game.title,
      earned: stickers.includes(level.reward.sticker),
    }));
  });

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFE66D]/40 to-[#8ecae6] px-4 py-8">
      <div className="mx-auto max-w-4xl">
        <div className="mb-8 flex flex-wrap items-center justify-between gap-4">
          <h1 className="font-display text-4xl font-bold text-white drop-shadow">
            Klistremerkebok
          </h1>
          <Link
            to="/"
            className="inline-flex min-h-[96px] min-w-[96px] items-center justify-center rounded-2xl bg-white px-6 font-display text-xl font-bold text-[#6441A5] shadow"
          >
            Hjem
          </Link>
        </div>

        <p className="mb-6 font-body text-white/90 text-lg">
          {stickers.length} klistremerker · {unlocks.length} opplåste ting
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {catalog.map((item) => (
            <div
              key={`${item.gameTitle}-${item.sticker}`}
              data-name={`sticker-slot-${item.sticker}`}
              className={`rounded-2xl p-4 text-center shadow ${
                item.earned ? 'bg-white' : 'bg-white/40'
              }`}
            >
              <div className="text-4xl mb-2" aria-hidden>
                {item.earned ? '⭐' : '🔒'}
              </div>
              <p className="font-display font-bold text-gray-800 text-sm">{item.title}</p>
              <p className="font-body text-xs text-gray-500">{item.gameTitle}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StickerBookPage;
